<ng-container *transloco="let t">
    <footer fxLayoutAlign="center space-between" fxFlexFill>
        <div
            class="footer-content"
            fxLayout="row"
            fxLayout.lt-md="column"
            fxFlex="90"
            fxLayoutAlign="space-between"
            fxLayoutAlign.lt-md="center center"
            fxLayout.lt-md="column"
            fxFlex.lt-md="100"
            fxFlexFill
        >
            <div class="footer-copyright">
                <a
                    href="https://literacypro.com/"
                    target="_blank"
                    rel="noopener"
                    >&copy; {{ today | date : "yyyy" }} LiteracyPro Systems Inc.
                    v{{ appVersion }}</a
                >
            </div>
            <div class="footer-terms">
                <a
                    href="javascript:void(0)"
                    (click)="navigation('terms-of-use')"
                    >{{ t("shared.link.terms-of-use") }}</a
                >
                |
                <a
                    href="javascript:void(0)"
                    (click)="navigation('privacy-policy')"
                    >{{ t("shared.link.privacy-policy") }}</a
                >
            </div>
        </div>
    </footer>
</ng-container>
